/**
 * Сторис на главной. Контент хардкодится здесь — новая новость = правка этого файла
 * (+ картинки в `public/stories/<id>/`) и мёрж в main, дальше автодеплой.
 *
 * Порядок в массиве = порядок в ленте. Истёкшие по `expiresAt` не показываются.
 */
export type Story = {
  /** Стабильный id: используется как ключ «просмотрено» в localStorage. */
  id: string;
  /** Подпись под кружком, 1–2 слова. */
  title: string;
  /** Картинка кружка. */
  cover: string;
  /**
   * Слайды, по 4:5 или вертикальные — показываются целиком, без обрезки.
   * Картинка (`.jpg`/`.png`) или видео (`.mp4`): видео проигрывается со звуком
   * выключенным и само перелистывает слайд по окончании. Для видео рядом должен
   * лежать постер с тем же именем и `.jpg` (см. `slidePoster`).
   */
  slides: string[];
  /** Кнопка внизу слайда — внешняя ссылка. Необязательна. */
  cta?: { label: string; href: string };
  /**
   * Запись на МК/курс прямо из приложения: кнопка «Записаться» открывает
   * оформление вместо внешней ссылки. `typeRecId` = запись «⚙️ Типы услуг».
   */
  enroll?: { label: string; typeRecId: string };
  /** Ссылка на первоисточник (пост в Telegram). */
  sourceUrl?: string;
  /** ISO-дата, после которой сторис пропадает из ленты. */
  expiresAt?: string;
};

export const STORIES: Story[] = [
  {
    // Новый формат клуба с 1 октября. Пять слайдов из карусели Вики для инсты
    // плюс её финальный, переделанный под кнопку; остальные («изучили обратную
    // связь» и т.п.) в приложении лишние. Ведём на /season — там цена для учениц добавкой к абонементу.
    id: "amani-club-season-1-2026-10",
    title: "AMANI club",
    cover: "/stories/amani-club-season-1/1.jpg",
    slides: [
      "/stories/amani-club-season-1/1.jpg",
      "/stories/amani-club-season-1/2.jpg",
      "/stories/amani-club-season-1/3.mp4",
      "/stories/amani-club-season-1/4.jpg",
      "/stories/amani-club-season-1/5.jpg",
      // Завершение: вместо «напиши "клуб" в комментариях» — зовём на кнопку.
      "/stories/amani-club-season-1/6.jpg",
    ],
    cta: { label: "Узнать подробнее", href: "https://club.amani-dance.com/season" },
    // Набор идёт до 1 октября — снимаем, когда закончится первый день сезона.
    expiresAt: "2026-10-02T00:00:00+03:00",
  },
  {
    // МК по завтракам с лекцией нутрициолога. Афиша плюс слайд с меню и ценой:
    // на самой афише цены нет, а без неё «Записаться» читается как кот в мешке.
    //
    // Ведём в запись прямо из приложения, а не на amani.by/breakfast: лендинг
    // спрашивает телефон на входе, а человек в приложении уже наш и залогинен —
    // просить у него номер второй раз незачем.
    id: "breakfast-balance-2026-09-19",
    title: "Завтраки",
    cover: "/stories/breakfast-balance/1.jpg",
    slides: [
      "/stories/breakfast-balance/1.jpg",
      "/stories/breakfast-balance/2.jpg",
    ],
    enroll: { label: "Записаться", typeRecId: "reczRqEeORq7cm2Fp" },
    // Мастер-класс заканчивается в 15:00 — снимаем с ленты сразу после него.
    expiresAt: "2026-09-19T15:00:00+03:00",
  },
  {
    // Повтор SUP-рассвета: первый разобрали за четыре дня, поэтому анонс идёт
    // первым в ленте. Слайды — новая афиша плюс видео с прошлой встречи: показать,
    // как это выглядит на воде, важнее, чем ещё раз показать текст.
    id: "sup-rassvet-2026-08-16",
    title: "SUP-рассвет",
    cover: "/stories/sup-rassvet-16/1.jpg",
    slides: [
      "/stories/sup-rassvet-16/1.jpg",
      // Видео с прошлой встречи переиспользуем: место то же, картинка живая,
      // а дублировать пять мегабайт в репозиторий незачем.
      "/stories/sup-rassvet/2.mp4",
      "/stories/sup-rassvet/3.mp4",
    ],
    enroll: { label: "Записаться", typeRecId: "rec336cwGOsGjYSYq" },
    // Встреча заканчивается в 6:40 утра — снимаем сразу после неё.
    expiresAt: "2026-08-16T07:00:00+03:00",
  },
  {
    id: "amani-club-2026-08",
    title: "AMANI club",
    cover: "/stories/amani-club-august/1.jpg",
    slides: ["/stories/amani-club-august/1.jpg"],
    cta: { label: "Узнать подробнее", href: "https://club.amani-dance.com" },
    // Программа на август — снимаем с ленты с началом сентября.
    expiresAt: "2026-09-01T00:00:00+03:00",
  },
  {
    id: "retro-party-2026-08-08",
    title: "Retro Party",
    cover: "/stories/retro-party/1.jpg",
    slides: ["/stories/retro-party/1.jpg", "/stories/retro-party/2.jpg"],
    // Ведём на страницу вечеринки, а не сразу в оплату: человек из сторис ещё не знает
    // ни программы, ни тайминга, а окно с суммой без этого читается как «плати сейчас».
    cta: { label: "Подробнее и записаться", href: "https://amani.by/retro" },
    // Вечеринка идёт вечером 8 августа — из ленты убираем ночью, когда всё закончится.
    expiresAt: "2026-08-08T20:00:00+03:00",
  },
  {
    id: "summer-party-2026-07-26",
    title: "Summer Party",
    cover: "/stories/summer-party/1.jpg",
    slides: [
      "/stories/summer-party/1.jpg",
      "/stories/summer-party/2.jpg",
      "/stories/summer-party/3.jpg",
      "/stories/summer-party/4.jpg",
    ],
    enroll: { label: "Записаться", typeRecId: "recGDu9K9kQPStIxx" },
    sourceUrl: "https://t.me/amani_minsk/1043",
    expiresAt: "2026-07-27T00:00:00+03:00",
  },
];

export const getActiveStories = (now: Date = new Date()): Story[] =>
  STORIES.filter((story) => !story.expiresAt || new Date(story.expiresAt) > now);

/** Видео-слайд (проигрывается в `<video>`), иначе — картинка в `<img>`. */
export const isVideoSlide = (slide: string): boolean => /\.(mp4|webm)$/i.test(slide);

/** Постер видео-слайда: тот же путь с `.jpg` (для размытой подложки и превью). */
export const slidePoster = (slide: string): string =>
  slide.replace(/\.(mp4|webm)$/i, ".jpg");
